module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-buttonbg-e1cb3c57160fb8ee0ed4a35bac6d5df8.svg";